import * as React from 'react';
import classnames from 'classnames';
import {Experiment} from '../../../reducers/experiments';
import {WithTranslation, withTranslation} from 'react-i18next';
import s from './currentLocation.scss';
import {RouteType} from '../../../routes/navigation';

export interface CurrentLocationProps {
  className?: string;
  experiments?: Experiment[];
  searchTerms?: string;
  label?: string;
  routeType?: RouteType;
}

class CurrentLocationCmp extends React.Component<CurrentLocationProps & WithTranslation> {
  getLabelText() {
    const {searchTerms, routeType, t} = this.props;

    if (searchTerms) {
      return `${t('wix.general.page.search.result')}: `;
    } else if (routeType === 'category') {
      return null;
    }
    return null;
  }

  render() {
    const {className, t, label, searchTerms} = this.props;
    const labelText = this.getLabelText();

    const labelClassName = classnames({
      [s.showing]: true,
      [s.searchLabel]: searchTerms,
      [className]: className,
    });

    const visibleLabel = (searchTerms ? searchTerms : t(label));

    return (<label
      aria-live="polite"
      data-hooks="page-header-showing-label"
      className={labelClassName}
    >
      {labelText}
      <strong>{visibleLabel}</strong>
    </label>);
  }
}

export const CurrentLocation =  withTranslation()(CurrentLocationCmp);
